import React from "react";
import styled from "styled-components";
import { graphql } from "gatsby";
import Layout from "../layouts/default";
import FeaturedBlogPost from "../sections/FeaturedBlogPost";
import BlogCard from "../components/BlogCard";
import Breakpoints from "../components/styles/Breakpoints";
import { Colors } from "../components/styles/Colors";

const Wrapper = styled.div``;

export const query = graphql`
  query BlogCategory($id: String) {
    contentfulBlogCategory(id: { eq: $id }) {
      name
      headline
      color
      description {
        description
      }
      blog_post {
        slug
        title
        image {
          fixed(width: 640, height: 640) {
            ...GatsbyContentfulFixed_withWebp
          }
        }
        category {
          headline
        }
        publishedDate
      }
    }
  }
`;

const Color = styled.div`
  background: ${Colors.cream1};
`;

const Grid = styled.div`
  max-width: 1440px;
  margin: 0 auto;

  padding: 64px 16px;

  @media ${Breakpoints.tablet} {
    display: grid;
    grid-template-columns: 33% 33% 33%;
    justify-content: center;

    grid-gap: 25px;

    > a {
      max-width: 480px;
      margin: 0 auto;

      .gatsby-image-wrapper {
        max-height: 480zpx;
      }
    }
  }
`;

export default function BlogCategory({ data, location }) {
  const category = data.contentfulBlogCategory;

  const cards = category.blog_post.map((p, i) => {
    if (i) {
      return <BlogCard post={p} />;
    }

    return null;
  });

  return (
    <Layout pathName={location.pathname}>
      <Wrapper>
        <FeaturedBlogPost category={category} post={category.blog_post[0]} />
        <Color>
          <Grid>{cards}</Grid>
        </Color>
      </Wrapper>
    </Layout>
  );
}
